@if (currentUser(); as user) {
      <ion-card class="user-card">
        <ion-card-header>
          <ion-card-title class="user-name">
            {{ user.firstName }}
          </ion-card-title>

          <div class="avatar-container">
            <ion-avatar class="user-avatar">
              @if (user.lastName) {
                <img [src]="user.avatar" [alt]="user.lastName || 'User avatar'" />
              } @else {
                <div class="avatar-placeholder">
                  <ion-icon name="person-outline"></ion-icon>
                </div>
              }
            </ion-avatar>
          </div>
        </ion-card-header>
        <ion-card-content>
          @if (user.loginName) {
            <div class="info-item">
              <ion-icon name="mail-outline" class="info-icon"></ion-icon>
              <span class="info-text">{{ user.loginName }}</span>
            </div>
          }
          @if (user.description) {
            <div class="info-item">
              <ion-icon name="person-outline" class="info-icon"></ion-icon>
              <span class="info-text">{{ user.description }}</span>
            </div>
          }
        </ion-card-content>
      </ion-card>
    } @else {
      <ion-card class="user-card">
        <ion-card-header>
          <div class="avatar-container">
            <ion-avatar class="user-avatar">
              <div class="avatar-placeholder">
                <ion-icon name="person-outline"></ion-icon>
              </div>
            </ion-avatar>
          </div>
          <ion-card-title class="user-name loading">Loading...</ion-card-title>
        </ion-card-header>
      </ion-card>
    }